import * as types from './mutation-types'
import Vue from 'vue'
import { ILayermapState } from './state'
import { MutationTree } from 'vuex/types'
import { DepthProfile } from '@/models/ui/DepthProfile';
import {i18n} from '@/locale/vueI18n'


/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<ILayermapState> = {
              
    [types.LAYERMAP_DEPTH_PROFILE_REQUEST]: (state) => {
        state.status = 'loading depth profile request'
        state.depthProfileLoading = true
    },
    [types.LAYERMAP_DEPTH_PROFILE_SUCCESS]: (state, depthProfile:DepthProfile) => {
        state.status = 'success loading depth profile request'        
        state.depthProfile = depthProfile
        state.depthProfileLoading = false
    },
    [types.LAYERMAP_DEPTH_PROFILE_ERROR]: (state) => {
        state.status = 'error loading depth profile request',
        state.depthProfile = new DepthProfile()
        state.depthProfileLoading = false
    },  
    [types.LAYERMAP_DEPTH_PROFILE_PROVIDER]: (state, providerName) => {
     state.depthProfileProvider = providerName
    }      
}


export default mutations
